import { render, staticRenderFns } from "./flowMoneyDetail.vue?vue&type=template&id=26d54032&scoped=true&"
import script from "./flowMoneyDetail.vue?vue&type=script&lang=js&"
export * from "./flowMoneyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d54032",
  null
  
)

export default component.exports